import { Component, OnInit , ElementRef, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';
import { Location } from '@angular/common';

@Component({
  selector: 'echexpayment-permission',
  templateUrl: './permission-add.component.html',
  styleUrls: ['./permission.component.css']
})
export class PermissionEditComponent implements OnInit {
	
	permission: any = {};
	createpermission: boolean = false;
	editpermission: boolean = true;
	public token: string;
	public addChecks = false
	public addUsers = false;
	public roleList : {};
	busy:Subscription;
	public CheckOtp: boolean=false;
	NamecharacterLimitReached: { [key: string]: boolean } = {};
	
	constructor(private router: Router, private location : Location, private toastr: ToastrService, private elementRef: ElementRef, private userService: UserService, private echexpaymentService :EchexpaymentService, private route: ActivatedRoute, private localStorageService: LocalstorageService) { 
		this.router = router; 
		var currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;
	
	}

	ngOnInit() {
		this.getRoleList();
		this.getEditPermission();
	}
	
	// get all roles in echexpayment
	getRoleList(){
		var data = {
			token:this.token,
		}
	  let responseData = <any>{};
	  this.busy = this.userService.getRoleLists(data).subscribe(
		 response => {
		 responseData = response;
			this.roleList  = responseData;   
		 },
		 error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
		 }
		);
	}
	// Get edit permission data
	getEditPermission() {
		let params: any = this.route.snapshot.params;
		let data = {
		  token:this.token,
		  id:params.id,
		}
		 let responseData = <any>{};
		 this.busy = this.echexpaymentService.getEditPermissionData(data).subscribe(
		   response => {
			  responseData = response;
			  this.permission = responseData.data;
		   },
		   error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);
	}


	//goBack
	goBack(){
		this.location.back();
	}
	// Update Permission
	updatePermission(data){
		this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid){
			    let model: any = data.value;
				let params: any = this.route.snapshot.params;
				model.token = this.token;
				model._id = params.id;
				let responseData = <any>{};
				this.busy = this.echexpaymentService.updatePermission(model).subscribe(
				response => {
						responseData = response;
						this.toastr.success(responseData.message, 'Success!');
						this.router.navigate(['/permisions']);
				},
				error => {
					responseData = error;
					this.toastr.error(responseData.error.message, 'Failed!');
				}
				);
		}
	}

	@ViewChild('submitButton') submitButton: ElementRef;
		  // Enter Key Focus Next Field
		  moveNext(nextInput: HTMLInputElement, checkbox: number) {
			if(checkbox === 2){
				if (this.submitButton && this.submitButton.nativeElement) {
					this.submitButton.nativeElement.focus();
					this.submitButton.nativeElement.click();
				}
			} else{
				nextInput && nextInput.focus();
			}
		}
		// Focus Error Field
		  focusFirstInvalidControlPlus(): void {
			  const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
			  if (firstElementWithErrors) {
				  firstElementWithErrors.focus();
			  }
		  }
	
			  // characters Limit check
			  NameCharacterLimit(event: any, fieldName: string) {
				const maxTextLength = 25; // Maximum text length of 20 characters
				const inputChar = event.key;
				const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
				const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
			  
				if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
				  return;
				}
			  
				const inputValue = event.target.value;
			  
				if (inputValue.length >= maxTextLength) {
				  if (allowedKeys.indexOf(inputChar) === -1) {
					this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
					setTimeout(() => {
					  this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
					}, 3000);
					event.preventDefault(); // Prevent entering the exceeded character
				  }
				}
			}
			  
		  isNameLimitReached(fieldName: string): boolean {
			  return this.NamecharacterLimitReached[fieldName];
		  }


		  @ViewChild('Roll_Id') selectBox: ElementRef;
		  ngAfterViewInit(){
				// this.renderer.selectRootElement('#initialFocus').focus();
				if (this.selectBox && this.selectBox.nativeElement) {
				  this.selectBox.nativeElement.focus();
				}
		  }


		  updateOtp(inputElement: HTMLInputElement) {
			const inputValue = inputElement.value.trim(); // Remove leading/trailing whitespace
			if (inputValue.length >= 1 && inputValue.length <= 5) {
			  this.CheckOtp = false;
			} else {
			  this.CheckOtp = true;
			}
		}
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/permission/permission-edit.component.ts